import express, { Router } from 'express';

import * as quotationValidation from '@/modules/quotation/quotation.validation';
import * as quotationController from '@/modules/quotation/quotation.controller';

import { validateMiddleware } from '@/shared/utils/middlewares/index';
import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';
import { setAuditFields } from '@/shared/middleware/setAuditFields';
import { AuditMode } from '@/shared/constants/enum.constant';
import { MODULE_LIST } from '@/shared/constants/module.constant';
import { ACTIONS } from '@/shared/constants';

const router: Router = express.Router();

router
  .route('/')
  .get(
    userAuthAndCheckPermissions(MODULE_LIST.QUOTATION, ACTIONS.READ),
    validateMiddleware(quotationValidation.getQuotation),
    quotationController.getQuotations,
  )
  .post(
    userAuthAndCheckPermissions(MODULE_LIST.QUOTATION, ACTIONS.CREATE),
    validateMiddleware(quotationValidation.createQuotation()),
    setAuditFields({ mode: AuditMode.CREATE, companyField: 'companyId' }),
    quotationController.createQuotation,
  );

router
  .route('/:id')
  .get(
    userAuthAndCheckPermissions(MODULE_LIST.QUOTATION, ACTIONS.READ),
    validateMiddleware(quotationValidation.getQuotationById),
    quotationController.getQuotationById,
  )
  .patch(
    userAuthAndCheckPermissions(MODULE_LIST.QUOTATION, ACTIONS.UPDATE),
    validateMiddleware(quotationValidation.updateQuotation()),
    setAuditFields({ mode: AuditMode.UPDATE }),
    quotationController.updateQuotation,
  )
  .delete(
    userAuthAndCheckPermissions(MODULE_LIST.QUOTATION, ACTIONS.DELETE),
    validateMiddleware(quotationValidation.deleteQuotationById),
    quotationController.deleteQuotationById,
  );

export default router;
